export function hasDuplicatesKeys<T extends object>(array: T[], key: keyof T): boolean {
    const seen = new Set<T[keyof T]>();

    for (const item of array) {
        const value = item[key];
        if (seen.has(value)) {
            return true; // Found a duplicate
        }
        seen.add(value);
    }

    return false; // No duplicates found
}
